/* unplugin-vue-components disabled */import script from "./Right.vue?vue&type=script&setup=true&lang=ts"
export * from "./Right.vue?vue&type=script&setup=true&lang=ts"

import "./Right.vue?vue&type=style&index=0&id=15be139f&lang=scss"

const __exports__ = script;

export default __exports__